module.exports = __webpack_public_path__ + "static/media/highlightPolicy.f14cb984.svg";